var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, bindable, DOM } from "aurelia-framework";
import { transient } from "aurelia-dependency-injection";
import { Guid } from "../../../utilities/guid";
import { computedFrom } from "aurelia-binding";
import { Reflection } from "../../../utilities/reflection";
import { StringUtilities } from "../../../utilities/strings";
import { BindingSignaler } from "aurelia-templating-resources";
var TextBox = /** @class */ (function () {
    function TextBox(element, bindingSignaler) {
        var _this = this;
        this.element = element;
        this.bindingSignaler = bindingSignaler;
        this._vm = this;
        this.decimalSeparator = ".";
        this.diffLength = 0;
        this.label = "";
        this.stopPropagationOnClick = true;
        this.startLabel = "";
        this.endLabel = "";
        this.readonly = false;
        this.disabled = false;
        this.type = "text";
        this.nullWhenEmpty = false;
        this.value = "";
        this.maxLength = 99999;
        this.filterMode = TextBox_1.FilterModes.change;
        this.placeholder = "";
        this.culture = "";
        this.pattern = "";
        this.decimalPlaces = 2;
        this.info = "";
        this.min = 0;
        this.max = 2147483647;
        this.allowNegative = false;
        this.onClick = function ($event) {
            if ($event && _this.stopPropagationOnClick) {
                $event.stopPropagation();
            }
        };
        this.onKeyDown = function (event) {
            var changeTextEvent = new CustomEvent("key-down", { detail: event, bubbles: true });
            _this.element.dispatchEvent(changeTextEvent);
        };
        this.cancelEvent = function (event) {
            if (_this.type === "numeric-password") {
                _this.stopEvent(event);
                return false;
            }
            return true;
        };
        this.identifier = Guid.generateGuid();
        this.valueSignaler = "textbox_" + this.identifier;
    }
    TextBox_1 = TextBox;
    Object.defineProperty(TextBox.prototype, "vm", {
        get: function () {
            return this._vm;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextBox.prototype, "internalType", {
        get: function () {
            if (this.type === "double" || this.type === "integer" || this.type === "float") {
                return "tel"; // to show numeric keyboard on mobile
            }
            if (this.type === "numeric-password") {
                return "tel"; // to show numeric keyboard on mobile
            }
            else {
                return this.type;
            }
        },
        enumerable: false,
        configurable: true
    });
    TextBox.prototype.attached = function () {
        this.isAttached = true;
        if (this.input) {
            this.input.addEventListener("click", this.onClick, false);
            this.input.addEventListener("keydown", this.onKeyDown, false);
            this.input.addEventListener("cut", this.cancelEvent, false);
            this.input.addEventListener("copy", this.cancelEvent, false);
            this.bindingSignaler.signal(this.valueSignaler);
        }
    };
    TextBox.prototype.valueChanged = function (newValue, oldValue) {
        var _this = this;
        this.registerChanges(oldValue, newValue);
        setTimeout(function () {
            _this.raiseTextChangedEvent(oldValue, newValue);
        });
    };
    TextBox.prototype.propertyChanged = function (property, newValue, oldValue) {
        switch (property) {
            case "decimalPlaces":
            case "type":
            case "readonly":
            case "disabled":
                {
                    if (this.input) {
                        this.bindingSignaler.signal(this.valueSignaler);
                    }
                }
                ;
                break;
            case "culture":
                {
                    var n = 1.1;
                    var nFormatted = newValue && newValue !== "" ? Intl.NumberFormat(newValue).format(n) : n.toString();
                    this.decimalSeparator = nFormatted[nFormatted.length - 2];
                    if (this.input) {
                        this.bindingSignaler.signal(this.valueSignaler);
                    }
                }
                ;
                break;
            default:
                break;
        }
    };
    TextBox.prototype.onFocus = function ($event) {
        this.isFocused = true;
        var event = DOM.createCustomEvent("focus", $event);
        this.element.dispatchEvent(event);
        if (this.filterMode.toLowerCase() === TextBox_1.FilterModes.focus) {
            if (this.filter) {
                this.value = this.filter($event.target.value);
            }
        }
    };
    TextBox.prototype.focusTextBox = function (selectAlltext) {
        if (selectAlltext === void 0) { selectAlltext = false; }
        var input = this.input;
        setTimeout(function () {
            input.focus();
            if (selectAlltext) {
                input.select();
            }
        });
    };
    TextBox.prototype.onBlured = function ($event) {
        this.isFocused = false;
        this.bindingSignaler.signal(this.valueSignaler);
        if (this.filterMode.toLowerCase() === TextBox_1.FilterModes.blur) {
            if (this.filter) {
                this.value = this.filter($event.target.value);
            }
        }
        var event = DOM.createCustomEvent("blur", $event);
        this.element.dispatchEvent(event);
    };
    TextBox.prototype.clearField = function () {
        this.value = null;
    };
    TextBox.prototype.detached = function () {
        if (this.input) {
            this.input.removeEventListener("click", this.onClick, false);
            this.input.removeEventListener("keydown", this.onKeyDown, false);
            this.input.removeEventListener("cut", this.cancelEvent, false);
            this.input.removeEventListener("copy", this.cancelEvent, false);
        }
    };
    TextBox.prototype.stopEvent = function (e) {
        if (e.stopPropagation) {
            e.stopPropagation();
        }
        if (e.preventDefault) {
            e.preventDefault();
        }
        e.cancelBubble = true;
        e.returnValue = false;
    };
    TextBox.prototype.registerChanges = function (oldValue, newValue) {
        this.previousValue = oldValue;
        this.currentValue = newValue;
    };
    TextBox.prototype.raiseTextChangedEvent = function (oldValue, newValue) {
        var paramsEvent = { detail: { oldValue: oldValue, newValue: newValue }, bubbles: true };
        var changeTextEvent = new CustomEvent("textchange", paramsEvent);
        this.element.dispatchEvent(changeTextEvent);
    };
    var TextBox_1;
    TextBox.FilterModes = {
        blur: "blur",
        focus: "focus",
        change: "change"
    };
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], TextBox.prototype, "label", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], TextBox.prototype, "stopPropagationOnClick", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], TextBox.prototype, "startLabel", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Function)
    ], TextBox.prototype, "filter", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], TextBox.prototype, "endLabel", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], TextBox.prototype, "readonly", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], TextBox.prototype, "disabled", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], TextBox.prototype, "type", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], TextBox.prototype, "nullWhenEmpty", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], TextBox.prototype, "value", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], TextBox.prototype, "maxLength", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], TextBox.prototype, "filterMode", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], TextBox.prototype, "placeholder", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], TextBox.prototype, "culture", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], TextBox.prototype, "pattern", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], TextBox.prototype, "decimalPlaces", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], TextBox.prototype, "info", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], TextBox.prototype, "min", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], TextBox.prototype, "max", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], TextBox.prototype, "identifier", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], TextBox.prototype, "allowNegative", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], TextBox.prototype, "tab", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], TextBox.prototype, "isFocused", void 0);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x._vm; })),
        __metadata("design:type", TextBox),
        __metadata("design:paramtypes", [])
    ], TextBox.prototype, "vm", null);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x.type; })),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], TextBox.prototype, "internalType", null);
    TextBox = TextBox_1 = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [Element, BindingSignaler])
    ], TextBox);
    return TextBox;
}());
export { TextBox };
var FormatterValueConverter = /** @class */ (function () {
    function FormatterValueConverter() {
    }
    FormatterValueConverter.prototype.isNegative = function (n) {
        return ((n = +n) || 1 / n) < 0;
    };
    FormatterValueConverter.prototype.getSign = function (value) {
        if (this.isNegative(value)) {
            return "-";
        }
        else {
            var firstChar = value && value.length > 0 ? value[0] : "";
            return firstChar == "+" || firstChar == "-" ? firstChar : "";
        }
    };
    FormatterValueConverter.prototype.repeat = function (text, count) {
        "use strict";
        if (text == null) {
            throw new TypeError("can't convert " + text + " to object");
        }
        var str = "" + text;
        count = +count;
        if (count !== count) {
            count = 0;
        }
        if (count < 0) {
            throw new RangeError("repeat count must be non-negative");
        }
        if (count === Infinity) {
            throw new RangeError("repeat count must be less than infinity");
        }
        count = Math.floor(count);
        if (str.length === 0 || count === 0) {
            return "";
        }
        // ensuring count is a 31-bit integer allows us to heavily optimize the
        // main part. But anyway, most current (August 2014) browsers can't handle
        // strings 1 << 28 chars or longer, so:
        if (str.length * count >= 1 << 28) {
            throw new RangeError("repeat count must not overflow maximum string size");
        }
        var rpt = "";
        for (;;) {
            if ((count & 1) == 1) {
                rpt += str;
            }
            count >>>= 1;
            if (count == 0) {
                break;
            }
            str += str;
        }
        // could we try:
        // return Array(count + 1).join(text);
        return rpt;
    };
    FormatterValueConverter.prototype.toView = function (value, param) {
        var textBox = param.vm;
        if (value == null || value == undefined) {
            value = "";
        }
        var sign = this.getSign(value);
        if (typeof value == 'number') {
            value = value.toString();
        }
        if ((sign == "+" || sign == "-") && value[0] == sign && ["double", "float", "integer"].indexOf(textBox.type) > -1) {
            value = value.substr(1);
        }
        if (textBox) {
            switch (textBox.type) {
                case "double":
                case "float":
                    {
                        if (value && value.toString() == "NaN") {
                            value = "";
                        }
                        var valueBeforeFormatting = value;
                        var decimal = value ? value.split(textBox.decimalSeparator)[1] : "";
                        var options = {
                            maximumFractionDigits: textBox.decimalPlaces,
                            minimumFractionDigits: textBox.readonly || textBox.disabled ? textBox.decimalPlaces : 0,
                            useGrouping: true
                        };
                        if (value) {
                            value = Number(value).toFixed(textBox.decimalPlaces);
                            value = textBox.culture && textBox.culture !== "" ?
                                Intl.NumberFormat(textBox.culture, options)
                                    .format(value) :
                                Intl.NumberFormat(navigator.language, options)
                                    .format(value);
                        }
                        if (valueBeforeFormatting && valueBeforeFormatting != value.replace(/,/g, "")) {
                            var index = value.indexOf(textBox.decimalSeparator);
                            value = value + (index === -1 ? textBox.decimalSeparator : "");
                            if (!textBox.isFocused) {
                                var fractionalPart = "";
                                var dec = value.split(textBox.decimalSeparator)[1];
                                if (dec) {
                                    if (dec.length < textBox.decimalPlaces) {
                                        fractionalPart = this.repeat("0", textBox.decimalPlaces - dec.length);
                                    }
                                    dec = dec + fractionalPart;
                                }
                                else {
                                    dec = this.repeat("0", textBox.decimalPlaces);
                                }
                                decimal = dec;
                                value = value + decimal;
                            }
                        }
                        if (value && decimal) {
                            value = value.split('.')[0] + textBox.decimalSeparator + decimal;
                        }
                        if (value === "NaN" || (value && value.toString().indexOf("NaN") > -1)) {
                            value = "";
                        }
                        if ((sign === "-" || sign === "+") &&
                            value.indexOf(sign) === -1 &&
                            textBox.allowNegative) {
                            value = sign + value;
                        }
                        //If number ends with . like 38. and decimalPlaces is 0 then we need to remove the dot
                        if (value && StringUtilities.endsWith(value, '.') && textBox.decimalPlaces == 0) {
                            value = value.substr(0, value.length - 1);
                        }
                    }
                    break;
                case "integer":
                case "numeric-password":
                    {
                        if (value && value.toString() == "NaN") {
                            value = "";
                        }
                        var options = {
                            maximumFractionDigits: 0,
                            useGrouping: true
                        };
                        value = this.removeAllButLast(value, textBox.decimalSeparator);
                        value = value ? value.replace(/[^0-9.]/g, "") : value;
                        if (value) {
                            switch (textBox.type) {
                                case "integer":
                                    value = Number(value).toFixed(0);
                                    break;
                            }
                            value = textBox.culture && textBox.culture !== "" ?
                                Intl.NumberFormat(textBox.culture, options)
                                    .format(value) :
                                value;
                        }
                        if (value === "NaN") {
                            value = "";
                        }
                        if ((sign === "-" || sign === "+") &&
                            value.indexOf(sign) === -1 &&
                            textBox.allowNegative) {
                            value = sign + value;
                        }
                    }
                    break;
                default:
                    break;
            }
        }
        return value;
    };
    FormatterValueConverter.prototype.fromView = function (value, param) {
        if (value && typeof value !== "string") {
            value = value.toString();
        }
        var textBox = param.vm;
        var fromViewValue = value;
        var caretIndex = null;
        var isNumber = false;
        var firstChar = value && value.length > 0 ? value[0] : "";
        if (textBox) {
            switch (textBox.type) {
                case "double":
                case "float":
                    {
                        caretIndex = textBox.input.selectionStart;
                        value = this.removeAllButLast(value, textBox.decimalSeparator);
                        value = value.replace(/[^0-9.]/g, "");
                        var decimal = value.split(textBox.decimalSeparator)[1];
                        if (decimal && decimal.length > textBox.decimalPlaces) {
                            value = Number(value).toFixed(textBox.decimalPlaces);
                        }
                    }
                    if ((firstChar === "-" || firstChar === "+") &&
                        value.indexOf(firstChar) === -1 &&
                        textBox.allowNegative) {
                        value = firstChar + value;
                    }
                    isNumber = true;
                    break;
                case "integer":
                    isNumber = true;
                case "numeric-password":
                    {
                        caretIndex = textBox.input.selectionStart;
                        value = value.replace(/[^0-9]/g, "");
                    }
                    if ((firstChar === "-" || firstChar === "+") &&
                        value.indexOf(firstChar) === -1 &&
                        textBox.allowNegative) {
                        value = firstChar + value;
                    }
                    isNumber = true;
                    break;
                case "text":
                    {
                        caretIndex = textBox.input.selectionStart;
                    }
                    break;
                case "email":
                    {
                        return value;
                    }
                default:
                    break;
            }
        }
        if (textBox.filterMode.toLowerCase() === TextBox.FilterModes.focus) {
            if (textBox.filter) {
                value = textBox.filter(value);
            }
        }
        if (isNumber) {
            textBox.input.value = this.toView(value, param);
            textBox.diffLength = Math.max(0, textBox.input.value.replace(/[^,]/g, "").length - textBox.diffLength);
            if (caretIndex != null) {
                caretIndex = caretIndex + Math.min(1, Math.max(0, (fromViewValue.lastIndexOf(textBox.decimalSeparator) == (fromViewValue.length - 1) ? 0 : textBox.diffLength)));
                textBox.input.setSelectionRange(caretIndex, caretIndex);
            }
        }
        if (textBox.nullWhenEmpty && value === "") {
            value = null;
        }
        return isNumber && value && !isNaN(value) ? Number(value) : value;
    };
    FormatterValueConverter.prototype.removeAllButLast = function (str, token) {
        var parts = str ? str.split(token) : [str];
        if (parts[1] === undefined) {
            return str;
        }
        else {
            return parts.slice(0, -1).join("") + token + parts.slice(-1);
        }
    };
    FormatterValueConverter = __decorate([
        autoinject,
        transient()
    ], FormatterValueConverter);
    return FormatterValueConverter;
}());
export { FormatterValueConverter };
